import { initializeCursor } from './shared/cursor.ts';
import { initializeParticles } from './shared/particles.ts';
import { initializeNavigation, initializeParallax, initializeScrollAnimations } from './shared/navigation.ts';

// Initialize homepage
function initHomePage() {
  // Initialize cursor
  initializeCursor();

  // Initialize particles
  initializeParticles();

  // Initialize navigation
  initializeNavigation();

  // Initialize parallax
  initializeParallax();

  // Initialize scroll animations
  initializeScrollAnimations();

  console.log('Home page initialized');
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHomePage);
} else {
  initHomePage();
}
